import React from 'react';
import { Link } from 'react-router-dom';
import Thumb from './Thumb';
import RightSide from './RightSide';

const Posts = ({ posts, recentPosts, comments, archieves, categories, tags  }) => (
  <section className="section blog-section section-light-grey">
      <div className="container">
          <div className="columns">
              <div className="column is-8">
                  { posts.map(p => (
                  <Thumb {...p} /> )) }
              </div>
              <RightSide
                recentPosts={recentPosts}
                comments={comments}
                archieves={archieves}
                categories={categories}
                tags={tags}
              />
          </div>
      </div>
  </section>
);

export default Posts;
